var app = angular.module('directives.sendreceipt');

app.directive('sendReceipt', ['PortalApi', 'Notification', 'Authentication', '$compile','$rootScope', 'Localization', 'Storage',
    function(PortalApi, Notification, Authentication, $compile,$rootScope, Localization, Storage) {
        return {
            scope: {pass:'=','opnd':'='},
            restrict: 'A',
            template: require('../templates/sendReceipt.html'),
            link: postLink
        };


        function postLink($scope, el, attrs, controller) {
            $scope.inputEmail = Authentication.user.email;

            $scope.close = function () {
                $scope.opnd = false;
            };

            // document.addEventListener("click", function(event) {
            //             if (event.target.closest("#popoverTarget")) {
            //             }else{
            //                 $scope.opnd = false;
            //             }
            // });

            attrs.$set('style', "position: absolute; height: 150px;bottom:100%;width: 224px; margin: 0 auto;");

            if(Storage.getItem('billsHistory')){
                $scope.billsHistory = JSON.parse(Storage.getItem('billsHistory'));
            }

            $scope.sendReceipt = function() {
                $scope.recLoader = true;

                if($scope.billsHistory){
                    var data = {
                        paymentId: attrs.paymentid,
                        email: $scope.inputEmail,
                        mobilePhone: attrs.mobilephone
                    };
                    // PortalApi.sendBillToMail(data).then(
                    PortalApi.sendPayDocuments(data).then(
                        function(res) {

                            if (res.status != 'ok') {
                                $scope.recLoader = false;

                                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CANT_SENT_BILL_TOMAIL', 5, true, $scope.inputEmail);
                            }

                            if (!Authentication.isLogged) {
                                Authentication.user.email = $scope.inputEmail;
                            }

                            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.BILL_SEND_TOMAIL', 5, true, $scope.inputEmail);

                            $scope.recLoader = false;
                            $scope.close();
                        },
                        function(reason) {
                            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CANT_SENT_BILL_TOMAIL', 5, true, $scope.inputEmail);
                            $scope.recLoader = false;
                        }
                    );
                }else{
                    PortalApi.sendPayDocuments({
                        paymentId: attrs.paymentid,
                        email: $scope.inputEmail
                    }).then(
                        function(res) {

                            if (res.status != 'ok') {
                                $scope.recLoader = false;
                                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CANT_SENT_BILL_TOMAIL', 5, true, $scope.inputEmail);
                            }

                            if (!Authentication.isLogged) {
                                Authentication.user.email = $scope.inputEmail;
                            }

                            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.BILL_SEND_TOMAIL', 5, true, $scope.inputEmail);

                            $scope.recLoader = false;
                            $scope.close();
                        },
                        function(reason) {

                            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.CANT_SENT_BILL_TOMAIL', 5, true, $scope.inputEmail);

                            $scope.recLoader = false;
                        }
                    );
                }
            }
        }

    }
]);

module.exports = 'directives.sendreceipt';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sendReceipt/directives/sendreceipt.directive.js
 ** module id = 220
 ** module chunks = 1
 **/